import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import slugify from 'slugify';

const Help = ({ text }) => {
  const [visible, setVisible] = useState(false);

  return (
    <span className="hst-help__container">
      <button
        aria-label={__('Help', 'hst')}
        className="hst-button hst-button__help"
        onClick={() => setVisible(!visible)}
        type="button"
      >
        ?
      </button>
      {visible ? (
        <div
          id={slugify(text)}
          className="hts-modal"
        >
          {text}
        </div>
      ) : null}
    </span>
  );
};

Help.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Help;
